import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import BotoneraBottom from '../Compartidos/BotoneraBottom';
import HeaderEjercicios from '../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../Escritorio/Instrucciones';
import useConfigAuth from '../../../Hooks/useConfigAuth';

import { finalizarEjercicioAction, setearEjercicioAction } from '../../../actions/estadoEjercicioActions';
import { almacenarAction } from '../../../actions/almacenarEjercicioActions';

// css
import { BotonCorrecto, BotonIncorrecto, ContainerFlex } from '../../Css/MetodosCSS/StyledLN2Todos';
import {Flex} from '../../Css/MetodosCSS/StyledCCIntrasilabica';
import { Img } from '../../Css/StyledForm';

const instrucciones = 'Vamos a ver letras, números y dibujos. Vas a tener que poner que si, si es una letra y que no, si no es una letra';
const miniInstrucciones = '';

const SCR9 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const [count, setCount] = useState(1);
    const [disable, setDisable] = useState(false);
    const [comparar, setComparar] = useState([]);
    const [indexes, setIndexes] = useState([]);
    const [resultado, setResultado] = useState([]);

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);

    const informacion = useSelector(state => state.informacion.info_DB);

    const resultadoBase = [
        {palabra_correcta:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ejemplo:""},
        {palabra_correcta:"", puntaje:"", ejemplo:""}
    ];

    const verifico = (e, nro) => {
        e.preventDefault();
        if(comparar.ejemplo == 1) {
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.palabra_1;
            newList[count-1].puntaje = "0";
            newList[count-1].ejemplo = 1;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                }, 100);
            } else {
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
            return
        }
        if(comparar.palabra_2 != nro) {
            console.log('mal');
            setDisable(true);
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.palabra_1;
            newList[count-1].puntaje = "0";
            newList[count-1].ejemplo = 0;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                }, 100);
            } else {
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
        } else {
            console.log('bien');
            setDisable(true);
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.palabra_1;
            newList[count-1].puntaje = "1";
            newList[count-1].ejemplo = 0;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                }, 100);
            } else {
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
        }
    }
    
    useEffect(() => {
        dispatch(setearEjercicioAction('SCR9') );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setComparar(informacion[count-1]);
        setIndexes(Object.keys(informacion).length);
    }, [count, informacion])
    
    useEffect(() => {
        setResultado(resultadoBase);
    }, [informacion])

    useEffect(() => {
        if(finalizar ){
            const informacion = {
                config,
                payload: {
                    'screening': true,
                    'ejercicio': "SCR9",
                    'resultado': resultado,
                    'id_paciente': id_paciente
                }
            }
            dispatch( almacenarAction(informacion) );
            navigate("/escritorio/metodos/finalizar-ejercicio");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);

    return (
        <Fragment>
            <HeaderEjercicios estrellas={true} carrito={true} minMay={false} ayuImagen={false} />
            {iniciar
                ?
                <ContainerFlex display="flex" direction="column" height="100%" width="100%">
                    {comparar.ejemplo ? 
                    <Flex margin="1rem 0 0 2rem" style={{fontSize:"40px", fontFamily:"Nunito", fontWeight:"bold", justifyContent:"start" }}>
                        Ejemplo
                    </Flex>
                    : null
                    }
                    <ContainerFlex display="flex" align="center" justify="center" margin="auto" direction="column">
                        <ContainerFlex>
                            <Img align="center" justify="center" src={`/img/${comparar.imagen_url_1}.png`} width="30vw" widthmob="30vw" />
                        </ContainerFlex>
                        <ContainerFlex display="flex" align="center" justify="center" margin="auto">
                            <ContainerFlex marginright="0.3rem">
                                <BotonCorrecto 
                                onClick={(e) => verifico(e, "1")} disabled={disable}/>
                            </ContainerFlex>
                            <ContainerFlex marginleft="0.3rem">
                                <BotonIncorrecto 
                                onClick={(e) => verifico(e, "0")} disabled={disable}/>
                            </ContainerFlex>
                        </ContainerFlex>
                    </ContainerFlex>

                    <ContainerFlex display="flex" justify="space-between" justifyself="end" margin="0 0 0.5rem 0">
                        <ContainerFlex>
                            <BotoneraBottom miniInstrucciones={miniInstrucciones} />
                        </ContainerFlex>
                    </ContainerFlex>
                </ContainerFlex>
                :
                <Instrucciones instrucciones={instrucciones} />
            }
        </Fragment>
    );
}
 
export default SCR9;